// hooks/useDataLayer.ts
import { useCallback } from "react";

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

const useDataLayer = () => {
  const pushToDataLayer = useCallback((data: Record<string, any>) => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    } else {
      console.warn("window not defined – dataLayer not pushed");
    }
  }, []);

  return pushToDataLayer;
};

export default useDataLayer;
